import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../firebase";
import { ProfileCollection, UserProfile } from "../types/Profile";

export function mapDocToUserProfile(id: string, data: any): UserProfile {
  return {
    userId: id,
    verifiedEmail: data.verifiedEmail,
    type: data.type,
    projects: data.projects ?? [],
  };
}

export async function getUserProfile(
  userId: string,
): Promise<UserProfile | null> {
  const profileDocRef = doc(firestore, ProfileCollection, userId);
  const profileDocSnap = await getDoc(profileDocRef);

  if (profileDocSnap.exists()) {
    const data = profileDocSnap.data();
    return mapDocToUserProfile(profileDocSnap.id, data);
  }
  return null;
}
